import ComingSoon from "@/components/ComingSoon";

const PortalLoginPage = () => {
  return <ComingSoon featureName="End-User Portal" description="Self-service portal for end users to manage their devices. This feature requires backend End-User Portal APIs." />;
};

export default PortalLoginPage;
